<template lang="pug">
  v-form(id="extra-items-form")
    v-row(justify="start", v-for="item in $options.items", :key="item.key")
      v-col(cols="3",
        :class="(item.type !== 'numValues' && item.type !== 'enum') ? 'd-flex align-center label-text' : 'label-text'") {{ item.name }}
      v-col(cols="3" v-if="item.type === 'int'", class="pt-2")
        v-text-field(
          dense,
          outlined,
          hide-details,
          single-line
          v-model.number="fields[item.key]",
          autocomplete="off",
          type="number")
      v-col(cols="9", v-if="item.type === 'enum'", class="pt-0")
        v-chip-group(
          column,
          v-model="fields[item.key]")
          v-chip(
            class="px-4",
            outlined,
            v-for="(val, index) in item.enumValues",
            :key="index",
            :value="val.text") {{ val.text }}
    v-row
      v-col(cols="3") Площадь квартиры, м2
      v-col(cols="3" class="pt-2")
        v-text-field(
          v-model.number="fields.areaOfApartmentsFrom",
          label="от",
          dense,
          outlined,
          hide-details,
          autocomplete="off",
          type="number")
      v-col(cols="3" class="pt-2")
        v-text-field(
          v-model.number="fields.areaOfApartmentsTo",
          label="до",
          dense,
          outlined,
          hide-details,
          autocomplete="off",
          type="number")
    v-row(align="center")
      v-col(cols="3") Стоимость за м2
      v-col(cols="3")
        v-text-field(
          v-model.number="fields.costPerM2",
          dense,
          outlined,
          hide-details,
          autocomplete="off",
          type="number")
      v-col(cols="2")
        v-select(
          v-model="fields.currency",
          :items="currencyList",
          item-text="text",
          item-value="key",
          dense,
          outlined, hide-details,
          label="Валюта")
</template>

<script>
export default {
  name: 'ExtraItems',

  props: {
    currencyList: {
      type: Array,
      default: () => []
    }
  },
  items: [
    { key: 'numberOfApartments', name: 'Число квартир', type: 'int' },
    {
      key: 'typeOfBuilding',
      name: 'Тип постройки',
      type: 'enum',
      enumValues: [
        { key: 'brick', text: 'Кирпич' },
        { key: 'panel', text: 'Панельный' },
        { key: 'monolith', text: 'Монолит' },
        { key: 'brickMonolith', text: 'Кирпич-монолит' },
        { key: 'block', text: 'Блок' }
      ]
    },
    { key: 'numberOfFloors', name: 'Этажность', type: 'int' },
    { key: 'ceilingHeight', name: 'Высота потолков, м', type: 'int' },
    {
      key: 'typeOfApartmentFinishes',
      name: 'Ремонт',
      type: 'enum',
      enumValues: [
        { key: 'hasFinished', text: 'Под ключ' },
        { key: 'forSelfFinishing', text: 'Для самостоятельной отделки' }
      ]
    },
    {
      key: 'parkingType',
      name: 'Тип парковки',
      type: 'enum',
      enumValues: [
        { key: 'forSell', text: 'Для продажи' },
        { key: 'notForSell', text: 'Недоступно для продажи' }
      ]
    }
  ],
  data: () => ({
    fields: {
      numberOfApartments: null,
      typeOfBuilding: 'Кирпич',
      numberOfFloors: null,
      ceilingHeight: null,
      typeOfApartmentFinishes: 'Для самостоятельной отделки',
      areaOfApartmentsFrom: null,
      areaOfApartmentsTo: null,
      parkingType: 'Для продажи',
      costPerM2: null,
      currency: 'som'
    }
  }),
  watch: {
    fields: {
      deep: true,
      handler(values) {
        this.$emit('set-fields', values)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.label-text {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.629525px;
  color: #000000;
}
#extra-items-form {
  .v-chip-group {
    .v-chip {
      color: #8e8e93 !important;
      background: #e5e5ea !important;
      border-color: transparent;
      &.v-chip--active {
        background-color: #07f !important;
        color: #fff !important;
        border-color: transparent;
      }
    }
  }
  .v-text-field {
    &__slot {
      input {
        font-size: 12px !important;
      }
    }
  }
  .fields {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .v-btn {
      width: 200px !important;
      height: 80px !important;
      border-radius: 6px !important;
      border: none !important;
      background-color: #fff !important;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
      color: #8e8e93 !important;
      font-weight: 700;
      margin-bottom: 22px;
      margin-right: 32px;
      &--active {
        color: #fff !important;
        background-color: #07f !important;
        opacity: 1 !important;
        box-shadow: none;
        &:before {
          opacity: 0 !important;
        }
      }
    }
  }
}
</style>
